import * as React from "react";
import { useTranslation } from "react-i18next";
const UNITS = {
  NANOSECONDS: "duration.nanoseconds",
  MICROSECONDS: "duration.microseconds",
  MILLISECONDS: "duration.milliseconds",
  SECONDS: "duration.seconds",
  MINUTES: "duration.minutes",
  HOURS: "duration.hours",
  DAYS: "duration.days"
};
const TimeUnit = ({ value, unit, zeroIsNever = true }) => {
  const { t } = useTranslation("common");
  if (value === 0 && zeroIsNever) {
    return /* @__PURE__ */ React.createElement("span", null, t("time.never"));
  }
  return /* @__PURE__ */ React.createElement("span", null, t(UNITS[unit], { count: value }));
};
export default TimeUnit;
